// DO NOT EDIT -- generated from fs/services/search-settings/spec.proto

import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as vars from '../../api/vars';

export namespace Specs {

  export const BatchGetSpecsEndpoint = "/grpc/search_settings.Specs/BatchGetSpecs";
  /** A request for the complete contents of one or more specs. */
  export function BatchGetSpecs(sender: (req: BatchGetSpecsRequest, endpoint: string) => Promise<BatchGetSpecsResponse>, req: BatchGetSpecsRequest): { promise: () => Promise<BatchGetSpecsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSpecsEndpoint),
      endpoint: BatchGetSpecsEndpoint
    };
  }

  export const BatchGetSpecConfigsEndpoint = "/grpc/search_settings.Specs/BatchGetSpecConfigs";
  /** A request to get all the spec configs for the org. */
  export function BatchGetSpecConfigs(sender: (req: BatchGetSpecConfigsRequest, endpoint: string) => Promise<BatchGetSpecConfigsResponse>, req: BatchGetSpecConfigsRequest): { promise: () => Promise<BatchGetSpecConfigsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSpecConfigsEndpoint),
      endpoint: BatchGetSpecConfigsEndpoint
    };
  }

  export const UpdateSpecConfigEndpoint = "/grpc/search_settings.Specs/UpdateSpecConfig";
  /** Updates the org's config for the spec, currently just whether it's active or not. */
  export function UpdateSpecConfig(sender: (req: UpdateSpecConfigRequest, endpoint: string) => Promise<UpdateSpecConfigResponse>, req: UpdateSpecConfigRequest): { promise: () => Promise<UpdateSpecConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSpecConfigEndpoint),
      endpoint: UpdateSpecConfigEndpoint
    };
  }

  export const BatchGetSpecObjectsEndpoint = "/grpc/search_settings.Specs/BatchGetSpecObjects";
  /**
   * A request for an arbitrary collection of spec objects, potentially from
   * multiple specs.
   */
  export function BatchGetSpecObjects(sender: (req: BatchGetSpecObjectsRequest, endpoint: string) => Promise<BatchGetSpecObjectsResponse>, req: BatchGetSpecObjectsRequest): { promise: () => Promise<BatchGetSpecObjectsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSpecObjectsEndpoint),
      endpoint: BatchGetSpecObjectsEndpoint
    };
  }

  export const BatchGetSpecObjectConfigsEndpoint = "/grpc/search_settings.Specs/BatchGetSpecObjectConfigs";
  /**
   * A request for configuration settings for an org's spec objects. The spec
   * objects may come from multiple specs.
   */
  export function BatchGetSpecObjectConfigs(sender: (req: BatchGetSpecObjectConfigsRequest, endpoint: string) => Promise<BatchGetSpecObjectConfigsResponse>, req: BatchGetSpecObjectConfigsRequest): { promise: () => Promise<BatchGetSpecObjectConfigsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSpecObjectConfigsEndpoint),
      endpoint: BatchGetSpecObjectConfigsEndpoint
    };
  }

  export const UpdateSpecObjectConfigEndpoint = "/grpc/search_settings.Specs/UpdateSpecObjectConfig";
  /**
   * A request to create or update a single spec object's configuration
   * settings.
   */
  export function UpdateSpecObjectConfig(sender: (req: UpdateSpecObjectConfigRequest, endpoint: string) => Promise<UpdateSpecObjectConfigResponse>, req: UpdateSpecObjectConfigRequest): { promise: () => Promise<UpdateSpecObjectConfigResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSpecObjectConfigEndpoint),
      endpoint: UpdateSpecObjectConfigEndpoint
    };
  }

  export const BatchGetSpecObjectMappingsEndpoint = "/grpc/search_settings.Specs/BatchGetSpecObjectMappings";
  /**
   * A request for an org's spec object mappings. The mappings may come from
   * multiple specs.
   */
  export function BatchGetSpecObjectMappings(sender: (req: BatchGetSpecObjectMappingsRequest, endpoint: string) => Promise<BatchGetSpecObjectMappingsResponse>, req: BatchGetSpecObjectMappingsRequest): { promise: () => Promise<BatchGetSpecObjectMappingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSpecObjectMappingsEndpoint),
      endpoint: BatchGetSpecObjectMappingsEndpoint
    };
  }

  export const UpdateSpecObjectMappingEndpoint = "/grpc/search_settings.Specs/UpdateSpecObjectMapping";
  /** A request to create or update a single spec object mapping for an org. */
  export function UpdateSpecObjectMapping(sender: (req: UpdateSpecObjectMappingRequest, endpoint: string) => Promise<UpdateSpecObjectMappingResponse>, req: UpdateSpecObjectMappingRequest): { promise: () => Promise<UpdateSpecObjectMappingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSpecObjectMappingEndpoint),
      endpoint: UpdateSpecObjectMappingEndpoint
    };
  }

  export const BatchUpdateSpecObjectMappingEndpoint = "/grpc/search_settings.Specs/BatchUpdateSpecObjectMapping";
  /** A request to create or update a batch of spec object mapping for an org. */
  export function BatchUpdateSpecObjectMapping(sender: (req: BatchUpdateSpecObjectMappingRequest, endpoint: string) => Promise<BatchUpdateSpecObjectMappingResponse>, req: BatchUpdateSpecObjectMappingRequest): { promise: () => Promise<BatchUpdateSpecObjectMappingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchUpdateSpecObjectMappingEndpoint),
      endpoint: BatchUpdateSpecObjectMappingEndpoint
    };
  }

  export const DeleteSpecObjectMappingEndpoint = "/grpc/search_settings.Specs/DeleteSpecObjectMapping";
  /** A request to delete a single spec object mapping for an org. */
  export function DeleteSpecObjectMapping(sender: (req: DeleteSpecObjectMappingRequest, endpoint: string) => Promise<DeleteSpecObjectMappingResponse>, req: DeleteSpecObjectMappingRequest): { promise: () => Promise<DeleteSpecObjectMappingResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteSpecObjectMappingEndpoint),
      endpoint: DeleteSpecObjectMappingEndpoint
    };
  }

  export const BatchDeleteSpecObjectMappingsEndpoint = "/grpc/search_settings.Specs/BatchDeleteSpecObjectMappings";
  /** A request to delete a group of spec object mappings for an org. */
  export function BatchDeleteSpecObjectMappings(sender: (req: BatchDeleteSpecObjectMappingsRequest, endpoint: string) => Promise<BatchDeleteSpecObjectMappingsResponse>, req: BatchDeleteSpecObjectMappingsRequest): { promise: () => Promise<BatchDeleteSpecObjectMappingsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchDeleteSpecObjectMappingsEndpoint),
      endpoint: BatchDeleteSpecObjectMappingsEndpoint
    };
  }

  export const GetSpecAdoptionEndpoint = "/grpc/search_settings.Specs/GetSpecAdoption";
  /** A request to get how much of the spec has been filled out */
  export function GetSpecAdoption(sender: (req: GetSpecAdoptionRequest, endpoint: string) => Promise<GetSpecAdoptionResponse>, req: GetSpecAdoptionRequest): { promise: () => Promise<GetSpecAdoptionResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSpecAdoptionEndpoint),
      endpoint: GetSpecAdoptionEndpoint
    };
  }

  export const BatchGetSpecObjectsForConversionsEndpoint = "/grpc/search_settings.Specs/BatchGetSpecObjectsForConversions";
  /** A request to get spec objects for conversions signals */
  export function BatchGetSpecObjectsForConversions(sender: (req: BatchGetSpecObjectsForConversionsRequest, endpoint: string) => Promise<BatchGetSpecObjectsForConversionsResponse>, req: BatchGetSpecObjectsForConversionsRequest): { promise: () => Promise<BatchGetSpecObjectsForConversionsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSpecObjectsForConversionsEndpoint),
      endpoint: BatchGetSpecObjectsForConversionsEndpoint
    };
  }
}

export interface BatchGetSpecsRequest {
  /**
   * The org making the request. There are no org-specific specs today, so this
   * is only used for authentication.
   */
  orgId: string;
  /** An optional filter indicating which specs to retrieve. */
  filter: SpecFilter | null;
}

export interface BatchGetSpecsResponse {
  specs: Spec[];
}

export interface SpecConfig {
  specSlug: string;
  active: boolean;
}

export interface BatchGetSpecConfigsRequest {
  orgId: string;
}

export interface BatchGetSpecConfigsResponse {
  specConfigs: SpecConfig[];
}

export interface UpdateSpecConfigRequest {
  orgId: string;
  specConfig: SpecConfig | null;
}

export interface UpdateSpecConfigResponse {
  specConfig: SpecConfig | null;
}

export interface BatchGetSpecObjectsRequest {
  /**
   * The org making the request. There are no org-specific specs today, so this
   * is only used for authentication.
   */
  orgId: string;
  /** An optional filter indicating which spec objects to retrieve. */
  filter: SpecObjectFilter | null;
}

export interface BatchGetSpecObjectsResponse {
  objects: SpecObject[];
}

export interface BatchGetSpecObjectConfigsRequest {
  /** The org for which spec object configs should be retrieved. */
  orgId: string;
  /** An optional filter indicating which spec object configs to retrieve. */
  filter: SpecObjectFilter | null;
}

export interface BatchGetSpecObjectConfigsResponse {
  configs: SpecObjectConfigRecord[];
}

export interface UpdateSpecObjectConfigRequest {
  /**
   * The org for which a spec object's configuration settings should be created
   * or updated.
   */
  orgId: string;
  /** The new spec object configuration settings. */
  config: SpecObjectConfig | null;
}

export interface UpdateSpecObjectConfigResponse {
  config: SpecObjectConfigRecord | null;
}

export interface BatchGetSpecObjectMappingsRequest {
  /** The org for which spec object mappings should be retrieved. */
  orgId: string;
  /** An optional filter indicating which spec object mappings to retrieve. */
  filter: SpecObjectMappingFilter | null;
  /**
   * An optional filter indicating which spec object properties to retrieve.
   * When supplied, it is assumed that only specific property results are desired and thus the object filter
   * will be further refined by the parent objects of the properties supplied here.
   * Additionally, the resulting mappings will only be partially hydrated based on selected properties.
   */
  propertyFilter: SpecPropertyFilter | null;
}

export interface BatchGetSpecObjectMappingsResponse {
  mappings: SpecObjectMappingRecord[];
}

export interface UpdateSpecObjectMappingRequest {
  /** The org for which a spec object mapping should created or updated. */
  orgId: string;
  /** The new spec object mapping. */
  mapping: SpecObjectMapping | null;
  /** Whether or not to retain existing properties or to update exactly with new mappings */
  retainExistingProperties: boolean;
  autosuggested: boolean;
}

export interface BatchUpdateSpecObjectMappingRequest {
  /** The org for which a spec object mapping should created or updated. */
  orgId: string;
  /** The new spec object mappings. */
  mappings: SpecObjectMapping[];
  /** Whether or not to retain existing properties or to update exactly with new mappings */
  retainExistingProperties: boolean;
  /** Whether or not to ignore the update request for mappings if a config was unmapped/skipped. */
  ignoreIfSkipped: boolean;
  /** Whether or not the mappings were autosuggested and mapped. */
  autosuggested: boolean;
}

export interface UpdateSpecObjectMappingResponse {
  mapping: SpecObjectMappingRecord | null;
}

export interface BatchUpdateSpecObjectMappingResponse {
  mappings: SpecObjectMappingRecord[];
}

export interface DeleteSpecObjectMappingRequest {
  /** The org for which a spec object mapping should be deleted. */
  orgId: string;
  /** The identity of the unwanted mapping. */
  mappingId: SpecObjectMappingId | null;
}

export interface DeleteSpecObjectMappingResponse {
  /** The deleted mapping. (This always matches the request.) */
  mappingId: SpecObjectMappingId | null;
}

export interface BatchDeleteSpecObjectMappingsRequest {
  /** The org for which spec object mappings should be deleted. */
  orgId: string;
  /** A filter indicating which spec object mappings to delete. */
  filter: SpecObjectMappingFilter | null;
}

export interface BatchDeleteSpecObjectMappingsResponse {
  /** The deleted mappings. */
  mappingIds: SpecObjectMappingId[];
}

export interface GetSpecAdoptionRequest {
  orgId: string;
}

export interface GetSpecAdoptionResponse {
  totalSpecObjects: protobuf.int64;
  specObjectsWithMappings: protobuf.int64;
  /** spec_objects_with_mappings / total_spec_objects for convenience */
  percentage: number;
}

export interface BatchGetSpecObjectsForConversionsRequest {
  orgId: string;
}

export interface BatchGetSpecObjectsForConversionsResponse {
  objects: ConversionsSpecSignals[];
}

export interface SpecFilter {
  /** An optional list of spec slugs to match. */
  specSlugs: string[];
}

export interface SpecObjectFilter {
  /** An optional list of spec slugs to match. */
  specSlugs: string[];
  /** An optional list of object slugs to match. */
  objectSlugs: string[];
}

export interface SpecObjectMappingFilter {
  /** An optional list of spec slugs to match. */
  specSlugs: string[];
  /** An optional list of object slugs to match. */
  objectSlugs: string[];
  /** An optional list of target DX object types to match. */
  targetObjectTypes: SpecTargetObjectType[];
  /** An optional list of target DX object ids to match. */
  targetObjectIds: string[];
}

export enum SpecTargetObjectType {
  SPEC_TARGET_OBJECT_TYPE_INVALID = 0,
  SPEC_TARGET_OBJECT_TYPE_ELEMENT = 1,
  SPEC_TARGET_OBJECT_TYPE_API_EVENT = 2,
  SPEC_TARGET_OBJECT_TYPE_DEFINED_EVENT = 3,
  SPEC_TARGET_OBJECT_TYPE_PAGE = 4
}

export interface SpecPropertyFilter {
  /** An optional list of spec slugs to match. */
  propertySlugs: string[];
}

/** Metadata for specs and the objects and properties they contain. */
export interface SpecMetadata {
  /**
   * The spec entity's name. Example: "Add to Cart Button". This can be useful
   * for presentation to humans, but it can be ambiguous. Use slugs to refer to
   * spec entities unambiguously.
   */
  name: string;
  /**
   * If true, this spec entity is deprecated. It may be appropriate to present
   * it differently or hide it in some contexts.
   */
  deprecated: boolean;
  /**
   * The spec entity's display name. If present, prefer this over the name for
   * presentation to humans.
   */
  displayName: string;
  /** Arbitrary notes. */
  notes: string;
  /** Arbitrary key/value attributes. */
  attributes: { [key: string]: string };
}

/** The definition of a spec. */
export interface Spec {
  /**
   * This spec's slug. Example: "E-commerce". This is an unambiguous, stable name
   * for this spec.
   */
  slug: string;
  metadata: SpecMetadata | null;
  /** The objects in this spec. */
  objects: SpecObject[];
}

/** The definition of a spec object. */
export interface SpecObject {
  /**
   * This object's slug. Example: "E-commerce/Add to Cart Button". This is an
   * unambiguous, stable name for this object.
   */
  slug: string;
  metadata: SpecMetadata | null;
  /** The target DX object types this spec object can be mapped to. */
  targetObjectTypes: SpecTargetObjectType[];
  /** This object's properties. */
  properties: SpecObjectProperty[];
}

/** The definition of a property on a spec object. */
export interface SpecObjectProperty {
  /**
   * This property's slug. Example: "E-commerce/Add to Cart Button/price". This
   * is an unambiguous, stable name for this property.
   */
  slug: string;
  metadata: SpecMetadata | null;
  /** The DX property types this spec property can be mapped to. */
  propertyTypes: vars.Type[];
}

/**
 * A customer's configuration for a spec object. This is for metadata that
 * applies to the spec object *in general* and not to any particular mapping.
 * The rule of thumb is that any piece of metadata that should persist even if
 * all of the spec object's mappings are deleted should live in the
 * configuration.
 */
export interface SpecObjectConfig {
  /** The spec object this configuration is for. */
  objectSlug: string;
  /** If true, the customer deliberately skipped mapping this object. */
  skipped: boolean;
  /** Arbitrary notes. */
  notes: string;
}

/** A SpecObjectConfig and its associated audit metadata. */
export interface SpecObjectConfigRecord {
  config: SpecObjectConfig | null;
  metadata: protoauditstore.AuditMetadata | null;
}

/** A mapping from a spec object to a customer's data object. */
export interface SpecObjectMapping {
  /** The spec object this mapping is for. */
  objectSlug: string;
  /** This mapping's target DX object's type. */
  targetObjectType: SpecTargetObjectType;
  /** This mapping's target DX object's ID. */
  targetObjectId: string;
  /** Property mappings for this mapping's target DX object. */
  properties: SpecPropertyMapping[];
}

/**
 * The identity of a spec object mapping, without the full details. Used to
 * identify a spec object mapping for operations like deletion which do not
 * require a complete definition.
 */
export interface SpecObjectMappingId {
  /** The spec object this mapping is for. */
  objectSlug: string;
  /** This mapping's target DX object's type. */
  targetObjectType: SpecTargetObjectType;
  /** This mapping's target DX object's ID. */
  targetObjectId: string;
}

/** A SpecObjectMapping and its associated audit metadata. */
export interface SpecObjectMappingRecord {
  mapping: SpecObjectMapping | null;
  metadata: protoauditstore.AuditMetadata | null;
  specObjectMappingRecordMetadata: SpecObjectMappingRecordMetadata | null;
}

export interface SpecObjectMappingRecordMetadata {
  /** Indicates whether the mapping was automatically suggested and mapped. */
  autosuggested: boolean;
}

/**
 * A mapping from a spec object property to a customer's DX property.
 * SpecPropertyMappings are always associated with a particular
 * SpecObjectMapping, and their meaning is determined by that context -- for
 * example, if the SpecObjectMapping targets an API event called `checkout`,
 * then an associated SpecPropertyMapping for an event-scoped property called
 * `total` refers to the `checkout` event's `total` property.
 */
export interface SpecPropertyMapping {
  /** The spec object property this mapping is for. */
  propertySlug: string;
  /** The target DX property's scope. */
  targetPropertyScope: vars.Scope;
  /** The target DX property's name. */
  targetPropertyName: string;
  /** The target DX property's type. */
  targetPropertyType: vars.Type;
}

export interface ConversionsSpecSignals {
  /** The spec object. */
  objectSlug: string;
  /** An optional property slug to filter on. */
  propertySlug: string;
  attributes: { [key: string]: string };
  notes: string;
}
